import { useState, useCallback, useEffect } from 'react'
import { searchAPI } from '../api/search.api'
import { Customer } from '../types/search.types'

export const useCustomerSearch = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [customers, setCustomers] = useState<Customer[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [hasSearched, setHasSearched] = useState(false)

  useEffect(() => {
    const searchCustomers = async () => {
      if (!searchQuery.trim() || searchQuery.trim().length < 2) {
        setCustomers([])
        setHasSearched(false)
        return
      }

      try {
        setLoading(true)
        setError(null)
        
        const response = await searchAPI.searchCustomers(searchQuery.trim())
        
        if (response.success) {
          setCustomers(response.data.customers || [])
          setHasSearched(true)
        } else {
          setError(response.message || 'Échec de la recherche de clients')
          setCustomers([])
        }
      } catch (err) {
        console.error('Error searching customers:', err)
        setError('Échec de la recherche de clients')
        setCustomers([])
      } finally {
        setLoading(false)
      }
    }

    // Debounce search
    const timeoutId = setTimeout(searchCustomers, 300)
    return () => clearTimeout(timeoutId)
  }, [searchQuery])

  const searchCustomers = useCallback((query: string) => {
    setSearchQuery(query)
  }, [])

  return {
    customers,
    loading,
    error,
    searchCustomers,
    searchQuery,
    setSearchQuery,
    hasSearched
  }
}